<template>
  <div class="AppLayout">
    <swiper class="AppLayout_swiper" :options="options" ref="bgSlider">
      <swiper-slide
        v-for="(slide, index) in slides"
        :key="index"
        data-aos="fade"
        data-aos-delay="100"
        data-aos-duration="2000"
      >
        <img class="AppLayout_image" :src="slide" alt="slide" />
      </swiper-slide>
    </swiper>

    <div class="AppLayout_content">
      <slot name="main"></slot>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "AppLayout",

  components: {
    swiper,
    swiperSlide,
  },

  props: {
    slides: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      options: {
        effect: "fade",
        autoplay: {
          delay: 10000,
        },
      },
    };
  },

  computed: {
    swiper() {
      return this.$refs.bgSlider.swiper;
    },
  },

  mounted() {
    this.swiper.on("slideChange", () => {
      this.$emit("chageTitle", this.swiper.activeIndex);
    });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/breackpoints.scss";

.AppLayout {
  position: relative;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  transition: all 0.25s ease;

  @media (max-width: $sm) {
    height: 100vh;
    // min-height: 600px;
  }

  &.blur {
    filter: blur(15px);
  }

  &_swiper {
    position: relative;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      background-color: rgba(#000000, 0.25);
    }
  }

  .swiper-container {
    height: 100%;
  }

  &_image {
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: center;
    font-family: "object-fit: cover; object-position: center;";
    /* filter: grayscale(100%); */
  }

  &_content {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 1;

    @media (max-width: $sm) {
      height: auto;
      overflow: scroll;
      // padding-top: 10px;
    }
  }
}
</style>
